



import {Component, Vue} from 'vue-property-decorator'
import SurveyDoneList from '@/components/survey/SurveyDoneList.vue'

@Component({
  components: {
    SurveyDoneList,
  },
})
export default class Done extends Vue {}
